import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateTwoPDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeEducation } from "lib/redux/types";

export const Education = ({
  heading,
  educations,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  educations: ResumeEducation[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateTwoPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {educations.map(
        (
          { school, degree, startDate, endDate, gpa, descriptions = [] },
          idx
        ) => {
          // Hide school name if it is the same as the previous school
          const hideSchoolName =
            idx > 0 && school === educations[idx - 1].school;
          const showDescriptions = descriptions?.join() !== "";

          return (
            <View key={idx} style={{ ...styles.flexRow, ...(idx !== 0 ? { marginTop: "6pt" } : {}) }} wrap={false}>
              <View style={{ width: "30%" }}>
                <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View style={{ ...styles.flexCol, width: "70%" }}>
                {!hideSchoolName && (
                  <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                    {school}
                  </ResumePDFText>
                )}
                <View
                  style={{
                    marginTop: hideSchoolName
                      ? "-3pt" // Reduced from spacing["1"] (12pt) to 3pt
                      : "4pt", // Reduced from spacing["1.5"] (18pt) to 4pt
                  }}
                >
                  <ResumePDFText style={{ lineHeight: "1.2" }}>{`${
                    gpa ? `${degree} - ${gpa}` : degree
                  }`}</ResumePDFText>
                </View>
                {showDescriptions && (
                  <View
                    style={{ ...styles.flexCol, marginTop: "3pt" }} // Reduced from spacing["1.5"] (18pt) to 3pt
                  >
                    <ResumePDFDescription 
                      items={descriptions} 
                      enableHighlight={enableHighlight}
                      enableMistakeHighlight={enableMistakeHighlight}
                      section="education"
                      itemIndex={idx}
                    />
                  </View>
                )}
              </View>
            </View>
          );
        }
      )}
    </TemplateTwoPDFSectionWithSubsections>
  );
};
